import { Separator } from "@gigpro/ui/Separator";
import { Skeleton } from "@gigpro/ui/Skeleton";
import { formatDate } from "@gigpro/utils/datetime";
import type { ProHistoryGig } from "api/resources/proProfile";
import { env } from "config/env";
import { isSameDay } from "date-fns";
import React from "react";
import { getCloudinaryImage } from "utils/cloudinary";
import { RatingDisplay } from "../RatingDisplay";
import { IMAGE_WIDTH } from "./constants";

type PROfileGigHistoryDetailProps = {
  gig: ProHistoryGig;
  previousGig: ProHistoryGig | undefined;
};

export const PROfileGigHistoryDetail: React.FC<PROfileGigHistoryDetailProps> = ({
  gig: { id, start_time, wage_amount, location, rating },
  previousGig,
}) => {
  const showDateHeading = !previousGig || !isSameDay(previousGig.start_time, start_time);
  return (
    <>
      {showDateHeading && !!previousGig && <Separator />}
      {showDateHeading && <p className="my-2 font-semibold">{formatDate(start_time, "EEEE, MMM d")}</p>}
      <div className="mb-2 flex w-full gap-3" data-testid={`gig_${id}`}>
        <img
          src={getCloudinaryImage(location.image_public_id ?? env.REACT_APP_DEFAULT_LOCATION_IMAGE_ID, {
            width: IMAGE_WIDTH,
            height: IMAGE_WIDTH,
            circle: true,
          }).toURL()}
          loading="lazy"
          alt={`Logo for ${location.name}`}
          width={IMAGE_WIDTH}
          height={IMAGE_WIDTH}
          className="self-start"
        />
        <div className="flex flex-1 flex-col">
          <p>{location.name}</p>
          <RatingDisplay rating={rating} />
        </div>
        {wage_amount !== null && <p>${wage_amount.toFixed(0)}/hr</p>}
      </div>
    </>
  );
};

export const PROfileGigHistoryDetailSkeleton: React.FC = () => (
  <>
    <Skeleton className="my-2 w-16 text-normal" />
    <div className="my-2 flex w-full gap-3">
      <Skeleton
        variant="circle"
        className="size-(--size)"
        style={{ "--size": `${IMAGE_WIDTH}px` } as React.CSSProperties}
      />
      <div className="flex flex-1 flex-col">
        <Skeleton className="w-28 text-normal" />
        <Skeleton className="w-8 text-normal" />
      </div>
      <Skeleton className="h-fit w-8 text-normal" />
    </div>
  </>
);
